import React from 'react';
import TwoOneLayout from '../components/TwoOneLayout';
import { Article, SectionData } from '../types/types';

interface CategoryTypeBProps {
  articlesData: Article[];
  sectionDatas: SectionData;
}

const CategoryTypeB: React.FC<CategoryTypeBProps> = ({ articlesData, sectionDatas }) => {
  return <TwoOneLayout articles={articlesData} sectionDatas={sectionDatas} />;
};

export default CategoryTypeB;
